import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import Icon from './Icon';
const ContentCard = ({ onClose, closeClasses, children, }) => {
    const allCloseClasses = classNames('absolute z-50 w-6 h-6 p-1 top-4 right-4 rounded-full transition-all duration-200 focus:outline-green hover:bg-green hover:text-white', closeClasses);
    return (_jsxs("div", { className: "relative overflow-hidden text-black bg-white shadow pointer-events-auto transition-all duration-300 hover:shadow-md", children: [children, _jsx("button", { "aria-label": "Close", className: allCloseClasses, onClick: onClose, children: _jsx(Icon, { name: "close", width: 16, height: 16 }) })] }));
};
export default ContentCard;
